import { render, staticRenderFns } from "./AssessmentDeviation.vue?vue&type=template&id=68c6c8d5&scoped=true"
import script from "./AssessmentDeviation.vue?vue&type=script&lang=js"
export * from "./AssessmentDeviation.vue?vue&type=script&lang=js"
import style0 from "./AssessmentDeviation.vue?vue&type=style&index=0&id=68c6c8d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c6c8d5",
  null
  
)

export default component.exports